import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';
import { TitleTextField } from '../../styles';
import ContentEditor from 'components/ContentEditor';
import { translate as t } from 'hooks/useTranslations';
import _ from 'lodash';

const EditablePanel = ({
  id,
  label,
  date,
  index,
  title,
  titleNumber,
  content,
  isPolicyEdit,
  editLevelTag,
  onTitleChange,
  onContentSave,
}: {
  id: string;
  label: string;
  date: string;
  index: number | string;
  title: string;
  titleNumber?: string;
  content: string;
  isPolicyEdit?: boolean;
  editLevelTag?: string;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onContentSave: (newContent: string) => void;
}) => (
  <Box
    id={id}
    sx={{
      backgroundColor: 'white',
      padding: 4,
      border: `1px solid ${neutral[200]}`,
      borderRadius: '6px',
      width: '50%',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, color: neutral[500] }}>
      <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
      <Typography>{date}</Typography>
    </Box>
    {editLevelTag && (
      <Box sx={{ mb: 2 }}>
        <Chip
          label={t(`draftManuals.editLevelTag.${editLevelTag}`)}
          variant='outlined'
          color='neutral'
          sx={{ textTransform: 'uppercase' }}
        />
      </Box>
    )}
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      {!_.isEmpty(titleNumber) && (
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 18,
            fontWeight: 600,
            color: neutral[500],
            mr: 2,
          }}
        >
          {titleNumber}
        </Typography>
      )}
      <TitleTextField
        id={`title_${id}`}
        variant='outlined'
        fullWidth
        value={title}
        inputProps={{ readOnly: false }}
        onChange={onTitleChange}
        sx={{ fontSize: 18, fontWeight: 600 }}
      />
    </Box>
    {!isPolicyEdit && (
      <Box sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
        <ContentEditor
          id={id}
          contentHTML={content}
          onSave={onContentSave}
          isEditable={true}
        />
      </Box>
    )}
  </Box>
);

export default EditablePanel;
